export enum SubscriptionFrequencyEnum {
	OptOut = 1,
	All = 2,
	Monthly = 3,
	Weekly = 4,
	Error = -99
}
